<div [innerHTML]="profileSpecialText.mainText" class="id37-text2 text-light"></div>
